import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-cpmOutdoorTypeShape",
  "use": "svg-icon-cpmOutdoorTypeShape-usage",
  "viewBox": "0 0 14 15",
  "content": "<symbol viewBox=\"0 0 14 15\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-cpmOutdoorTypeShape\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14 0H0v8h6v7h2l.002-7H14V0zm-2 2H2v4h10V2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol